import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import PersonIcon from "@mui/icons-material/Person";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import HistoryIcon from "@mui/icons-material/History";
import CategoryIcon from "@mui/icons-material/Category";
import MicIcon from "@mui/icons-material/Mic";
import UserManagement from "./UserManagement";
import ButtonConfig from "./ButtonConfig";
import ActivityLogs from "./ActivityLogs";
import CategoryManagement from "./CategoryManagement";
import VoiceContracts from "./VoiceContracts";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const SimpleAppAdmin = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box m="20px">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box>
          <Typography variant="h2" color={colors.grey[100]} fontWeight="bold">
            Einfache App Verwaltung
          </Typography>
          <Typography variant="h5" color={colors.greenAccent[400]}>
            Verwalten Sie Benutzer und Aktionen für die mobile App
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: colors.primary[400],
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          textColor="secondary"
          indicatorColor="secondary"
        >
          <Tab
            icon={<PersonIcon />}
            iconPosition="start"
            label="Benutzer"
            sx={{ fontSize: "14px" }}
          />
          <Tab
            icon={<TouchAppIcon />}
            iconPosition="start"
            label="Aktions-Buttons"
            sx={{ fontSize: "14px" }}
          />
          <Tab
            icon={<HistoryIcon />}
            iconPosition="start"
            label="Aktivitätsprotokoll"
            sx={{ fontSize: "14px" }}
          />
          <Tab
            icon={<CategoryIcon />}
            iconPosition="start"
            label="Kategorien"
            sx={{ fontSize: "14px" }}
          />
          <Tab
            icon={<MicIcon />}
            iconPosition="start"
            label="Gesprächsdokumentation"
            sx={{ fontSize: "14px" }}
          />
        </Tabs>
      </Box>

      <Box
        backgroundColor={colors.primary[400]}
        borderRadius="0 0 8px 8px"
        p={3}
      >
        <TabPanel value={tabValue} index={0}>
          <UserManagement />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <ButtonConfig />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <ActivityLogs />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <CategoryManagement />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <VoiceContracts />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default SimpleAppAdmin;
